import React from "react";
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";

function Footer() {
  // const year = new Date().getFullYear(); // Gets the current year

  return (
    <Box
      sx={{
        py: 2, // Padding top and bottom
        px: 3, // Padding left and right
        mt: "auto", // Margin top auto for sticking to bottom if using flex layout in parent
        // backgroundColor: "primary.main", // Use theme primary color
        color: "white", // Text color
        textAlign: "center", // Center text alignment
      }}
    >
      {/* <Typography variant="body1">© {year} CCL</Typography> */}
    </Box>
  );
}

export default Footer;
